import React, { PureComponent } from 'react';
import { Icon, Input, message } from 'antd';
import { api } from '$app/api';

import { StyledAutoComplete } from './styled';
import { isValidUkPostcode, normalizeUkPostcode } from './utils';

const SEARCH_DEBOUNCE_MS = 250;
const ERROR_MESSAGE_COOLDOWN_MS = 5000;

/**
 * UK postcode suggestion lookup (Ideal Postcodes / backend `/postcodes/:code/addresses`).
 */
class PostcodeLookup extends PureComponent {
  isUnmounted = false;

  pendingSearchTimeout = null;

  requestSequence = 0;

  lastErrorMessageAt = 0;

  constructor(props) {
    super(props);
    this.state = {
      suggestions: [],
      fetched: false,
    };
  }

  componentWillUnmount() {
    this.isUnmounted = true;
    this.requestSequence += 1;
    if (this.pendingSearchTimeout) {
      clearTimeout(this.pendingSearchTimeout);
    }
  }

  showLoadErrorOnce = () => {
    const now = Date.now();
    if (now - this.lastErrorMessageAt < ERROR_MESSAGE_COOLDOWN_MS) return;
    this.lastErrorMessageAt = now;
    message.error('Could not load addresses for this postcode');
  };

  fetchSuggestions = (postcode, requestId) => {
    api
      .get(`/postcodes/${encodeURIComponent(postcode)}/addresses`)
      .then(({ data: suggestions }) => {
        if (this.isUnmounted || requestId !== this.requestSequence) return;
        this.setState({ suggestions, fetched: true });
      })
      .catch((err) => {
        if (this.isUnmounted || requestId !== this.requestSequence) return;
        console.error('PostcodeLookup: failed to fetch addresses', err);
        this.setState({ suggestions: [], fetched: true });
        this.showLoadErrorOnce();
      });
  };

  handleSearch = (value) => {
    if (this.pendingSearchTimeout) {
      clearTimeout(this.pendingSearchTimeout);
      this.pendingSearchTimeout = null;
    }

    this.requestSequence += 1;
    const requestId = this.requestSequence;

    const normalizedPostcode = normalizeUkPostcode(value);
    if (!normalizedPostcode || !isValidUkPostcode(normalizedPostcode)) {
      this.setState({ suggestions: [], fetched: false });
      return;
    }

    this.setState({ fetched: false });
    this.pendingSearchTimeout = setTimeout(() => {
      this.fetchSuggestions(normalizedPostcode, requestId);
    }, SEARCH_DEBOUNCE_MS);
  };

  onSelect = (value) => {
    const { suggestions } = this.state;
    const selected = suggestions.find((address) => address.display === value);
    if (!selected) return;
    this.props.onSelectAddress({
      ...selected,
      country: selected.countryISOCode || 'GB',
    });
  };

  render() {
    const { fetched, suggestions } = this.state;

    return (
      <StyledAutoComplete
        size="small"
        style={{ width: '90%' }}
        dataSource={fetched ? suggestions.map((a) => a.display) : []}
        onSelect={this.onSelect}
        onSearch={this.handleSearch}
        placeholder="Postcode eg. M126BN"
      >
        <Input suffix={<Icon type="search" className="certain-category-icon" />} />
      </StyledAutoComplete>
    );
  }
}

export default PostcodeLookup;
